import { useTranslation } from 'react-i18next';
import './style.css';
import { Icon } from '@iconify/react/dist/iconify.js';

const FinalConfirmation = ({ onSubmit, isLoading }) => {
    const { t } = useTranslation();

    return (
        <div className="final-confirmation-section">
            <div className="final-confirmation-info-card">
                <div className="final-confirmation-icon">
                    <Icon icon="ph:seal-check-fill" width="1.2em" height="1.2em" />
                    <h3 className="final-confirmation-info-title">{t('final-confirmation')}</h3>
                </div>
                <div className="final-confirmation-info-text">
                    <p className="final-confirmation-info-description">
                        {t('confirm-patient-arrival-initiate-medical-procedure')}
                    </p>
                </div>
            </div>


        </div>
    );
};

export default FinalConfirmation;

